import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.sitecontrolhq.com";
const DEFAULT_IMAGE = `${SITE_URL}/schq-logo.png`;
const DEFAULT_TITLE = "SiteControlHQ | Field Service Management & Job-Costing Software for Contractors";
const DEFAULT_DESC = "Offline-first field service software for contractor fleets: dispatch, AI job checklists, e-signed estimates, in-field card and ACH payments, and QuickBooks or Xero sync.";

export function Seo({
  title,
  description,
  path = "",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title || DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1"}
      />
      <meta property="og:site_name" content="SiteControlHQ" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {blocks.map((obj, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
